import "./person-type-info-pane.styl"
import template from "./person-type-info-pane.pug"
import { PopupPane } from "@/lib/components/popup/popup-pane"
import { ObservableData } from "@/lib/utils/observable-data"

export class PersonTypeInfoPane extends PopupPane
   constructor: ->
      super(template())
